import { action, observable } from 'mobx'

import Ds from './ds'

class Accessories {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllAccessories() {
    this.ds.query(`{ accessories(hash: "${ localStorage.getItem('userHash') }") { id name description baseCost } }`, (data) => {
      this.data = data.accessories
    })
  }

  @action newAccessory(row) {
    this.ds.query(`mutation { addAccessory(name: "${ row.name }", description: "${ row.description }", baseCost: ${ row.baseCost }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllAccessories()
    })
  }

  @action updateAccessory(row) {
    this.ds.query(`mutation { updateAccessory(id: ${ row.id }, name: "${ row.name }", description: "${ row.description }", baseCost: ${ row.baseCost }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllAccessories()
    })
  }

  @action deleteAccessory(id) {
    this.ds.query(`mutation { deleteAccessory(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllAccessories()
    })
  }
}

export default new Accessories()



// WEBPACK FOOTER //
// ./src/stores/accessories.js